module.exports = __webpack_public_path__ + "static/media/blog-gear2.76876b03.jpg";